import { ConsentPrivacySection } from "@/features/patient/consent/components/ConsentPrivacyView";
import { sampleConsentItems } from "@/data/patient/consent.mock";
import { SsnConsentCard } from "@/portals/patient/pages/profile/SsnConsentCard";

export function ConsentPrivacyPage() {
  return <ConsentPrivacySection items={sampleConsentItems} extraCards={<SsnConsentCard />} />;
}
